// featured/auth/context/AuthContext.js
import { createContext,setState, useContext, useState, useEffect } from 'react';
import {login as apiLogin, mfaVerification, refreshTokenR,organismos,ventasPorDia,eula, eulaFirmed,ventasPorHora,equipos,empleados,topproductos,inventario,password, passwordMfa,forgotPassword} from '../api/auth'
import { storageService } from '../service/storage';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [sessionId, setsessionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [isEulaAccepted, setIsEulaAccepted] = useState(false);
  const [changepass, setChangePass] = useState(false);
  const [stepOneForgotPassword, setStepOneForgotPassword] = useState(false);
  const [mfaForgotPass,setMfaForgotPass] = useState(false);
  const [changeEmail,setChangeEmail] = useState(false);
useEffect(() => {
  const restoreSession = async () => {
    console.log("Inicio restore session");

    const stored = storageService.getAll();
    console.log("token :" + stored.token);
    console.log("refreshtoken :" + stored.refreshToken);
    console.log("storedsessionid :" + stored.sessionId);
    console.log("accesstokenexpires :" + stored.accessExpires);
    console.log("refreshtokenexpires :" + stored.refreshExpires);
    console.log("eulaFirmed :" + stored.eulaFirmed);
    console.log("fullName :" + stored.fullName);

    // 1. Restaurar sessionId si existe (para flujo MFA pendiente)
    if (!stored.sessionId || stored.sessionId === 'undefined') {
      console.log("No hay sessionId - mostrando login");
      setLoading(false);
      return;  // ← sessionId permanece null, App.js muestra LoginPage
    }

    // 2. Si no hay token, es flujo MFA pendiente (no limpiar sessionId)
    if (!stored.token) {
      console.log("SessionId existe pero no hay token - flujo MFA");
      setsessionId(stored.sessionId);  // ← Ahora sí, porque sabemos que es MFA real
      setLoading(false);
      return;
    }

    const now = new Date();
    const accessExpiry = stored.accessExpires ? new Date(stored.accessExpires) : null;
    const refreshExpiry = stored.refreshExpires ? new Date(stored.refreshExpires) : null;

    if (!accessExpiry || !refreshExpiry) {
      console.log('Fechas de expiración no encontradas, limpiando sesión');
      cleanSession();
      setLoading(false);
      return;
    }

    // ✅ 4. Token expirado pero refresh válido → intentar renovar
    if (now >= accessExpiry && now < refreshExpiry) {
      console.log("Access token expirado, intentando refresh...");
      try {
        const refreshResponse = await refreshTokenR(stored.refreshToken);
        if (!refreshResponse || !refreshResponse.data) {
          throw new Error('Refresh falló');
        }
        
        const newTokens = refreshResponse.data;
        storageService.setTokens({
          accessToken: newTokens.accessToken,
          refreshToken: newTokens.refreshToken || stored.refreshToken,
          accessTokenExpires: newTokens.accessTokenExpires,
          refreshTokenExpires: newTokens.refreshTokenExpires
        });
        storageService.setUserData(newTokens.fullName);
        
        // ✅ Sesión renovada - restaurar todo
        setsessionId(stored.sessionId);
        setIsVerified(true);
        if (stored.eulaFirmed === "true" || stored.eulaFirmed === true) {
          setIsEulaAccepted(true);
        }
        console.log("Refresh exitoso, sesión restaurada");
        
      } catch (error) {
        console.error('Error al refrescar token:', error);
        cleanSession();
      }
      setLoading(false);
      return;
    }
    
    // ✅ 5. Token aún válido → restaurar sesión completa
    if (now < accessExpiry) {
      console.log("Token vigente, restaurando sesión");
      setsessionId(stored.sessionId);
      setIsVerified(true);
      
      if (stored.eulaFirmed === "true" || stored.eulaFirmed === true) {
        setIsEulaAccepted(true);
      }
      
      setLoading(false);
      return;
    }

    // ✅ 6. Ambos tokens expirados → limpiar todo
    console.log("Ambos tokens expirados");
    cleanSession();
    setLoading(false);
  };

  restoreSession();
}, []);

  const cleanSession = () => {
    storageService.clear();
    setsessionId(null);
    setIsVerified(false);
  };

  const login = async (credentials) => {
    console.log("the bininging");
    
    // Guardar credenciales en sessionStorage (temporal)
    storageService.setCredentials(credentials.identifier, credentials.password);
    
    const data = await apiLogin(credentials);
    const realdata = data.data;
    
    console.log(realdata.sessionId);
    console.log(realdata);
    
    // Guardar session en localStorage
    storageService.setSession(realdata.sessionId);
    setsessionId(realdata.sessionId);
  };

  const mfaVerify = async (payload) => {
    console.log("payload:", payload);
    const data = await mfaVerification(payload);
    const realdata = data.data;
    storageService.setUserData(realdata.fullName)
    console.log(realdata);
    
    if (!realdata.accessToken || !realdata.refreshToken) {
      throw new Error('Tokens no recibidos');
    }
    
    // Guardar tokens mediante el servicio
    storageService.setTokens({
      accessToken: realdata.accessToken,
      refreshToken: realdata.refreshToken,
      accessTokenExpires: realdata.accessTokenExpires,
      refreshTokenExpires: realdata.refreshTokenExpires
    });

    storageService.setEulaFirmed(realdata.eulaFirmed)

    if (realdata.eulaFirmed === "true" || realdata.eulaFirmed === true) {
      console.log("Eula tiene que ser true",realdata.eulaFirmed)
      setIsEulaAccepted(true);
    }
    setIsVerified(true);
    
    return realdata;
  };

  const mfaResend = async () => {
    // Obtener credenciales de sessionStorage
    const { identifier, password } = storageService.getCredentials();
    
    if (!identifier || !password) {
      throw new Error('Credenciales no disponibles. Por favor inicie sesión nuevamente.');
    }
    
    await login({identifier, password });
  };


  const logout = () => {
    setLoading(true);
    cleanSession();
    setTimeout(() => setLoading(false), 500);
  };

  const getEula = () => {
    return eula();
  }

  const acceptEula = async () => {
    try {
      const response = await eulaFirmed(true);
      setIsEulaAccepted(true);
      storageService.setEulaFirmed(true);
      console.log("Eula accepted:", response);
      return response;
    } catch (error) {
      console.error("Error accepting EULA:", error);
      throw error;
    }
  };

  const notAcceptEula = () => {
    setIsEulaAccepted(false);
    storageService.setEulaFirmed(false)
    setLoading(true);
    storageService.clearSensitive();
    setsessionId(null);
    setIsVerified(false);
    setTimeout(()=>{
        setLoading(false);
    },500)
  }

  const getVentasPorDia = async (fecha)=>{
    console.log("get ventas por dia")
    console.log(fecha)
    const dataVentas = await ventasPorDia(fecha);
    console.log("Devuelve ventas por dia")
    console.log(dataVentas)
    return dataVentas
  }

  const getVentasPorHora = async (fecha)=>{
    console.log("get ventas por hora")
    console.log(fecha)
    const dataVentas = await ventasPorHora(fecha);
    console.log("Devuelve ventas por hora")
    console.log(dataVentas)
    return dataVentas
  }

  const getEquipos = async (fecha) => {
    console.log("get equipos")
    console.log(fecha)
    const dataEquipos = await equipos(fecha);
    console.log("Devuelve equipos")
    console.log(dataEquipos)
    return dataEquipos
  }

  const getEmpleados = async (fecha) => {
    const dataEmpleados = await empleados(fecha)
    return dataEmpleados;
  }

  const getTopproductos = async (fecha) => {
    const dataTopproductos = await topproductos(fecha)
    return dataTopproductos;
  }

  const getOrganismos = async (fecha) => {
    const dataOrganismos = await organismos(fecha);
    return dataOrganismos;
  }

  const getInventario = async (fecha) => {
    const dataInventario = await inventario(fecha);
    return dataInventario;
  }

  const changePassMethod = (bool) => {
    console.log("Inside method", changepass)
    setChangePass(bool)
  }
  //contiene los datos del primer informe como el codigo de farmacia y correo
  const stepOneChangePass = async (obj) => {
    return await forgotPassword(obj)
  }
  //Manda el objeto con la nueva contraseña
  const setPass = async (obj) => {
    await password(obj);
  }
  
  const sendForgotPassMfa = async (obj) => {
    const data = await passwordMfa(obj);
    const realdata = data.data;
    console.log("REALDATA",realdata);
    /*
    if (!realdata.accessToken || !realdata.refreshToken) {
      throw new Error('Tokens no recibidos');
    }*/
    

    return realdata;
  }
  const changeMfaForgotPass = (bool) => {
    console.log("QUIERO CAMBIARLO A ",bool)
    setMfaForgotPass(bool)
    console.log("mfaForgotPass",mfaForgotPass)
  }

  const directSetPass = async () => {
    setChangePass(true)
    setStepOneForgotPassword(true)
    setMfaForgotPass(true)
  }

    const restartSetPass = async () => {
    setChangePass(false)
    setStepOneForgotPassword(false)
    setMfaForgotPass(false)
  }

  const value = {
    sessionId,
    loading,
    isVerified,
    isEulaAccepted,
    changepass,
    stepOneForgotPassword,
    mfaForgotPass,
    changeEmail,
    login,
    mfaVerify,
    logout,
    getVentasPorDia,
    getVentasPorHora,
    getEquipos,
    getEmpleados,
    getTopproductos,
    getOrganismos,
    getInventario,
    mfaResend,
    getEula,
    setIsEulaAccepted,
    acceptEula,
    notAcceptEula,
    changePassMethod,
    setPass,
    setStepOneForgotPassword,
    stepOneChangePass,
    sendForgotPassMfa,
    changeMfaForgotPass,
    directSetPass,
    restartSetPass,
    setChangeEmail
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};